import { getHomeCaseCount } from '@components/LocalMerchant/Decoration/util'
import {
  CASE_MANAGE_PATH,
  DECORATION_EXAMPLE,
  PROPERTY_WEDDING_DRESS_ID
} from '@constant'
import {
  isWeddingDressPhotoProperty,
  isWeddingDressProperty,
  isWeddingPlanProperty
} from '@merchant-backend/util'
import { createArr, getMerchantInfo } from '@util'
import { Flex } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Header from '../Common/Header'
import More from '../Common/More'
import Rowbox from '../Common/Rowbox'
import DressItem from './DressItem'
import Item from './Item'
import PlanItem from './PlanItem'
import style from './style.module.less'
import TagList from './Tag'
import WeddingPhotoTagList from './Tag/WeddingPhoto'

@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getCaseList()
    this.props.store.getMealCasePropertyList()
  }

  getTileByPropertyId = () => {
    const { property_id } = getMerchantInfo()

    // 婚纱礼服
    if (property_id == PROPERTY_WEDDING_DRESS_ID) {
      return '新人案例'
    } else {
      return '商家作品'
    }
  }

  render() {
    const { example, mode } = this.props.store
    let { total_count, list } = example
    list = list || []
    const hasContent = list.length > 0
    const vertical = false
    const homeCount = getHomeCaseCount()
    const { property_id } = getMerchantInfo()

    if (property_id == PROPERTY_WEDDING_DRESS_ID) {
      return ''
    }

    return mode === 'editable' || (mode === 'preview' && +total_count > 0) ? (
      <Rowbox
        type={DECORATION_EXAMPLE}
        store={this.props.store}
        style={{
          flexDirection: 'column',
          height: 'auto'
        }}
        vCenter={false}
      >
        <Header title={this.getTileByPropertyId()} />

        {!isWeddingDressProperty() && <TagList />}

        {isWeddingDressPhotoProperty() && <WeddingPhotoTagList />}

        {/* 婚纱礼服案例没有了，待删除 */}
        {/* https://qnm.hunliji.com/o_1dnrvld0l1jjao138ge11kn13g6e.png */}
        {isWeddingDressProperty() && (
          <div className={style.list}>
            {hasContent
              ? list.map(item => <DressItem key={item.id} {...item} />)
              : createArr(homeCount).map(item => (
                  <DressItem key={item.id} mode="fake" />
                ))}
          </div>
        )}

        {/* 婚礼策划 */}
        {/* https://qnm.hunliji.com/o_1dnrvjdhop99ecu1ds31j6hm4k9.png */}
        {isWeddingPlanProperty() && (
          <Flex className={style.list} sp wrap>
            {hasContent
              ? list.map(item => <PlanItem key={item.id} {...item} />)
              : createArr(homeCount).map(item => (
                  <PlanItem key={item.id} mode="fake" />
                ))}
          </Flex>
        )}

        {/* 非婚礼策划和非婚纱礼服用统一 */}
        {!isWeddingDressProperty() &&
          !isWeddingPlanProperty() && (
            <Flex
              className={style.list}
              style={{
                overflowX: vertical ? 'visible' : 'auto'
              }}
              d={vertical ? 'v' : 'h'}
            >
              {hasContent
                ? list.map(item => (
                    <Item key={item.id} {...item} vertical={vertical} />
                  ))
                : createArr(homeCount).map(item => (
                    <Item key={item.id} mode="fake" vertical={vertical} />
                  ))}
            </Flex>
          )}

        {total_count > list.length && (
          <More text={`全部${total_count}个作品`} link={CASE_MANAGE_PATH} />
        )}
      </Rowbox>
    ) : null
  }
}
